/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earn_Accumulator_Page_Meta_TitleInputs */

const en_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const de_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const pt_br2_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const tr_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const zh_cn2_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const zh_hk2_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const ko_kr2_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const ru_ru2_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

const es_419_earn_accumulator_page_meta_title = /** @type {(inputs: Earn_Accumulator_Page_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boosted Limit Orders | Glider`)
};

/**
* | output |
* | --- |
* | "Boosted Limit Orders \| Glider" |
*
* @param {Earn_Accumulator_Page_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const earn_accumulator_page_meta_title = /** @type {((inputs?: Earn_Accumulator_Page_Meta_TitleInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earn_Accumulator_Page_Meta_TitleInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earn_accumulator_page_meta_title(inputs)
	if (locale === "de") return de_earn_accumulator_page_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_earn_accumulator_page_meta_title(inputs)
	if (locale === "tr") return tr_earn_accumulator_page_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_earn_accumulator_page_meta_title(inputs)
	if (locale === "zh-HK") return zh_hk2_earn_accumulator_page_meta_title(inputs)
	if (locale === "ko-KR") return ko_kr2_earn_accumulator_page_meta_title(inputs)
	if (locale === "ru-RU") return ru_ru2_earn_accumulator_page_meta_title(inputs)
	return es_419_earn_accumulator_page_meta_title(inputs)
});